import React, { useEffect, useState } from 'react'
import type { TFunction } from 'i18next'
import { PricePerRoomChart } from '../../../PricePerRoomChart'

import { useRentalMarket } from '../../RentalMarketContext'

interface RentalPricePerRoomProps {
  t: TFunction
}

export const RentalPricePerRoom: React.FC<RentalPricePerRoomProps> = ({
  t,
}) => {
  const { filters, service, priceMode } = useRentalMarket()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<any>({})

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      setError(null)

      try {
        // Determine location type and value from filters
        let locationType = undefined
        let locationValue = undefined

        if (filters.location) {
          switch (filters.locationType) {
            case 'postal_code':
              locationType = 'postal_code_name'
              break
            case 'city':
              locationType = 'municipality_name'
              break
            case 'district':
              locationType = 'district_name'
              break
          }
          locationValue = filters.location
        }

        // Calculate date range for last 12 months
        const endDate = new Date()
        const startDate = new Date()
        startDate.setMonth(startDate.getMonth() - 12)

        const apiFilters = {
          deal_type: 'rent', // Changed from 'purchase' to 'rent'
          property_category:
            filters.propertyCategory.length > 0
              ? filters.propertyCategory
              : undefined,
          location: locationValue,
          location_type: locationType,
          active_listing_timestamp: {
            min: startDate.toISOString().split('T')[0],
            max: endDate.toISOString().split('T')[0],
          },
          outlier_field: 'price',
          outlier_percentage: 2,
        }

        const response = await service.getRentalPricePerRoomData(apiFilters)
        setData(response.aggregations)
      } catch (err) {
        console.error('Error fetching rental price per room data:', err)
        setError(t('market.common.errors.loadingData'))
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [filters])

  return (
    <PricePerRoomChart
      data={data}
      loading={loading}
      error={error}
      isRental={true}
      priceMode={priceMode}
      t={t}
      showInsights={false}
      showKPIs={false}
    />
  )
}
